import axios from 'axios';
import { resolveExistingIdentityQuery } from './queries';

/**
 * PFM-3029: exact-match identity check for the shared link control.
 * The canonical `eligible` / `not_available` contract passes through
 * untouched; transport/quota failures become typed errors the control can
 * render as its `error` state. Identifiers are never logged client-side
 * beyond the request itself.
 */
const resolveExistingIdentity = async ({ role, subuser = false, identifier }) => {
    try {
        const query = resolveExistingIdentityQuery({ model: { role, subuser, identifier } });
        const response = await axios.post(query.url, { ...query.body });
        return { data: response.data };
    } catch (error) {
        const statusCode = error?.response?.status || error?.statusCode;
        if (statusCode === 429) {
            const limited = new Error('Too many checks in a short time. Please wait a few minutes and try again.');
            limited.statusCode = 429;
            throw limited;
        }
        if (statusCode === 503 || statusCode === 502) {
            const unavailable = new Error('Identity lookup temporarily unavailable');
            unavailable.statusCode = 503;
            throw unavailable;
        }
        const message = error?.response?.data?.message || error?.response?.data?.error?.code || error?.response?.data?.error || error?.message;
        const formattedError = new Error(message);
        formattedError.statusCode = statusCode;
        formattedError.response = error?.response;
        throw formattedError;
    }
};

export default resolveExistingIdentity;
